import { state } from 'cerebral'
import apiClient from '../../lib/util/api-client'

const service = apiClient.service('info')

export const getInfo = async ({ store }) => {
  const { enabled, downloads, cards = [], messages = [] } = await service.find()
  store.merge(state`info`, { enabled, downloads, cards, messages })
}
